<script lang="ts">
  import { useViewType } from '@/ui/state/use-text-state.svelte';

  import Editor from './Editor.svelte';
  import type { EditorProps } from './Editor.types';

  let props: EditorProps = $props();
  let viewType = useViewType();
  let mode = $derived(props.mode ?? ($viewType === 'text-generator' ? 'generator' : 'editor'));
</script>

{#key props.text.id}
  {#if $viewType !== 'new'}
    <div class="h-full max-h-full">
      <Editor {...props} {mode} />
    </div>
  {/if}
{/key}
